/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { AnyAction } from '@reduxjs/toolkit';
import * as actionTypes from '../constants/action-types';

export interface Authentication {
  showPermissionDenied: boolean;
}

const authentication = (

  state: Authentication = {
    showPermissionDenied: false,
  },

  action: AnyAction

) => {

  switch (action.type) {

    case actionTypes.SHOW_PERMISSION_DENIED:
      return { ...state, showPermissionDenied: true }
    case actionTypes.HIDE_PERMISSION_DENIED:
      return { ...state, showPermissionDenied: false }

    default:
      return state;

  }

}

export default authentication;
